import { Component } from '@angular/core';
import { KENDO_BUTTON } from '@progress/kendo-angular-buttons';
import { TranslatePipe } from '@ngx-translate/core';
import { BookDemoDirective } from '../../directives/book-demo.directive';

@Component({
  selector: 'maximizer-showcase-cases-page',
  standalone: true,
  imports: [KENDO_BUTTON, TranslatePipe, BookDemoDirective],
  templateUrl: './cases.page.html',
  styleUrl: './cases.page.scss',
})
export class CasesPage {}
